import * as React from "react";
import Button from "../components/Button";
import Typography from "../components/Typography";
import ProductHeroLayout from "./ProductHeroLayout";
import AppAppBar from "./AppAppBar";
import Link from "@mui/material/Link";

const backgroundImage =
  "https://images.unsplash.com/photo-1580582932707-520aed937b7b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1932&q=80";

export default function ProductHero() {
  return (
    <ProductHeroLayout
      sxBackground={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: "#7fc7d9", // Average color of the background image.
        backgroundPosition: "center",
      }}
    >
      {/* Increase the network loading priority of the background image. */}
      <img
        style={{ display: "none" }}
        src={backgroundImage}
        alt="increase priority"
      />
      <AppAppBar/>
      <Typography color="inherit" align="center" variant="h2" marked="center">
        SARAN CENTRAL SCHOOL
      </Typography>
      <Typography
        color="inherit"
        align="center"
        variant="h5"
        sx={{ mb: 4, mt: { xs: 5, sm: 10 } }}
      >
        Nurturing minds, shaping futures.
      </Typography>
      <Button
        color="secondary"
        variant="contained"
        size="large"
        component={Link}
        href="https://wa.me/9060203615?text=Hi,%20can%20you%20please%20call%20me%20back%20on%20this%20number?"
        sx={{ minWidth: 200, borderRadius: 2 }}
      >
        Contact
      </Button>
      <Typography variant="body2" color="inherit" sx={{ mt: 2 }}>
        Discover the experience
      </Typography>
    </ProductHeroLayout>
  );
}
